import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { ScrollingModule } from '@angular/cdk/scrolling';

// Composants graphiques
import { BootstrapPopupComponent } from './components/bootstrap-popup.component';

// Services
import { BootstrapPopupService } from './services/bootstrap-popup.service';

@NgModule({
	imports: [
		BrowserModule,
		
		// Ce module est indispensable a ce que les drop-down d'autocompletion de composants
		// comme filterable-select disparaissent quand l'utilisateur scrolle
		ScrollingModule,
	],
	providers: [
		BootstrapPopupService,
	],
	declarations: [
		BootstrapPopupComponent,
	],
	exports: [
		BootstrapPopupComponent,
	]
})
export class BootstrapPopupModule {
	constructor() { }
}